import React from "react";

const CarsCheckOutNormalization = ({ row }) => {
  return <div>{row?.carsCheckedOut?.toLocaleString()}</div>;
};

export default CarsCheckOutNormalization;
